import { Heart } from 'lucide-react';
import { ScrollArea } from '@/components/ui/scroll-area';
import BottomSheetPanel from '@/components/BottomSheetPanel';
import ClickableUserDisplay from '@/components/ClickableUserDisplay';
import { useMediaVoters } from '@/hooks/useMediaVoters';
import { useTranslation } from '@/hooks/useTranslation';

interface VotesPanelProps {
  mediaId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

const VotesPanel = ({ mediaId, isOpen, onClose }: VotesPanelProps) => {
  const { voters, loading } = useMediaVoters(mediaId, isOpen);
  const { t } = useTranslation();

  return (
    <BottomSheetPanel
      isOpen={isOpen}
      onClose={onClose}
      title={t('votes')}
      count={voters.length}
    >
      {() => (
        <ScrollArea className="flex-1 min-h-0 px-6 pb-6">
          {loading ? (
            <div className="py-8 text-center text-muted-foreground">{t('loading')}</div>
          ) : voters.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-8 text-center">
              <Heart className="w-12 h-12 text-muted-foreground/50 mb-2" />
              <p className="text-muted-foreground">{t('noVotesYet')}</p>
            </div>
          ) : (
            <div className="space-y-3 pb-4">
              {voters.map((voter) => (
                <ClickableUserDisplay
                  key={`${voter.user_id}-${voter.voted_at}`}
                  userId={voter.user_id}
                  displayName={voter.display_name || 'Usuario'}
                  avatarUrl={voter.avatar_url}
                  variant="compact"
                />
              ))}
            </div>
          )}
        </ScrollArea>
      )}
    </BottomSheetPanel>
  );
};

export default VotesPanel;
